<!--<app-navbar></app-navbar>
<router-outlet>
</router-outlet>
<app-footer></app-footer>-->


<app-navbar></app-navbar>

<div class="container-fluid bg-color">
    <div class="container">
        <div class="row">
            <!-- Side Menu -->
            <div class="col-sm-3" *ngIf="showMenu">
                <app-side-menu></app-side-menu>
            </div>

            <!-- Routed Page Content -->
            <div [ngClass]="showMenu ? 'col-md-9' : 'col-md-12'">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
